<mat-form-field *ngIf="masterpKeywords && pTicket" class="ticket-keyword-form" appearance="fill">
  <mat-chip-grid #chipList aria-label="Keyword list" [formControl]="keywordCtrl">
    <mat-chip
      *ngFor="let keyword of pKeywords"
      [removable]="!keywordCtrl.disabled"
      (removed)="removeKeyword(keyword)">
      {{ keyword.pkw_value }}
      <button matChipRemove *ngIf="!keywordCtrl.disabled">
        <mat-icon>cancel</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-grid>

  <input
    class="keyword-input"
    placeholder="Add keyword to Ticket"
    [formControl]="keywordCtrl"
    [matAutocomplete]="autocompleteRef!"
    [matChipInputFor]="chipList"
    [matChipInputAddOnBlur]="true"
    [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
    (matChipInputTokenEnd)="addKeyword($event)">

  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectKeyword($event)">
    <mat-option *ngFor="let option of filteredKeywords | async" [value]="option.mpk_value">
      {{ option.mpk_value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>